import React from 'react';
import { steps } from '../../data/websites';
export function HowItWorks() {
  return <section aria-labelledby="how-it-works" className="bg-white px-[clamp(1rem,4vw,6rem)] py-20 lg:py-28" data-id="element-872" data-mp="1e4pgspizlcmy">
      <p className="text-sm font-bold uppercase tracking-[0.14em] text-brand-red" data-id="element-873" data-mp="19d7b5o60qnvn">How it works</p>
      <h2 id="how-it-works" className="mt-3 text-[clamp(2rem,3vw,3.5rem)] font-extrabold leading-tight tracking-tight text-brand-black" data-id="element-874" data-mp="14f5x5hng9er1">
        As easy as sending a text.
      </h2>

      <ol className="relative mt-14 grid gap-12 md:grid-cols-3 md:gap-10 xl:gap-16" data-id="element-875" data-mp="ug6v4hx6whd0">
        <span className="absolute left-6 right-6 top-6 hidden h-px bg-gray-200 md:block" aria-hidden="true" data-id="element-876" data-mp="qecxyjm7dvhl" />
        {steps.map((step, i) => <li key={step.title} className="relative" data-id="element-877" data-mp="lhcsoax6gwrj" data-mpi={i}>
            <span className="relative flex h-12 w-12 items-center justify-center rounded-full bg-brand-red text-lg font-extrabold text-white ring-8 ring-white" data-id="element-878" data-mp="2ktfkq9jvazgt">
              {i + 1}
            </span>
            <h3 className="mt-6 text-[clamp(1.375rem,1.6vw,1.875rem)] font-bold text-brand-black" data-id="element-879" data-mp="151jo2dcvl8uz">{step.title}</h3>
            <p className="mt-2 max-w-[42ch] text-[clamp(1rem,1.1vw,1.25rem)] leading-relaxed text-gray-600" data-id="element-880" data-mp="1a27dwvpdbjnm">{step.body}</p>
            {step.example && <p className="mt-4 inline-block rounded-2xl rounded-bl-sm bg-brand-light px-4 py-3 text-sm font-medium text-brand-black" data-id="element-881" data-mp="w3prr2f42f7t">
                {step.example}
              </p>}
          </li>)}
      </ol>
    </section>;
}